import { employeeItemComponent } from './employee/employee.item.component';
import { PersonService } from '../../services/person.service';
import { StaffService } from '../../services/staff.service';
import { employeeListComponent } from './employee/employee.list.component';
import {
    settingsCompanyState,
    settingsEmployeeItemState,
    settingsEmployeeListState,
    settingsEmployeeState,
    settingsState,
    templatesState,
    timezonesItemState,
    timezonesListState,
    timezonesState,
    settingsSalaryScaleState,
    settingsSalaryScaleEditState,
    staffState,
    staffListState,
    staffItemState,
    masterdataListEditState,
    masterdataState,
    masterdataListState,
    nmbrsTestState,
    twinfieldTestState,
    hourCodesState,
    hourCodesListState,
    hourCodesItemState
} from './settings.states';
import { settingsCompanyComponent } from './company/settings.company.component';
import { settingsComponent } from './settings.component';
import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { TemplatesService, MasterdataAService } from "../../services/index";
import { SalaryScaleGroupService, SalaryScaleService } from "../../services/salaryScaleGroup.service";
import { templatesEditorComponent } from "./templates/templatesEditor.component";
import { TimezonesService } from "../../services/timezone.service";
import { timezonesComponent } from "./timezones/timezones.component";
import { timezonesListComponent } from "./timezones/timezones.list.component";
import { timezonesItemComponent } from "./timezones/timezones.item.component";
import { timezonesItemBasicComponent } from "./timezones/timezones.item.basic.component";
import { HourCodeService } from "../../services/hourCode.service";
import { hourCodesComponent } from "./hourCodes/hourCodes.component";
import { hourCodesListComponent } from "./hourCodes/hourCodes.list.component";
import { hourCodesItemComponent } from "./hourCodes/hourCodes.item.component";
import { hourCodesItemBasicComponent } from "./hourCodes/hourCodes.item.basic.component";
import { salaryScaleListComponent } from './salaryScales/salaryScale.list.component';
import { salaryScalesDialogComponent } from './salaryScales/salaryScale.dialog.component';
import { staffComponent } from './staff/staff.component';
import { staffListComponent } from './staff/staff.list.component';
import { staffItemComponent } from './staff/staff.item.component';
import { masterdataComponent } from './masterdata/masterdata.component';
import { masterdataListComponent } from './masterdata/masterdata.list.component';
import { masterdataEditComponent } from './masterdata/masterdata.edit.component';
import { nmbrsTestComponent } from './nmbrsTest/nmbrsTest.component';
import { NmbrsService } from '../../services/nmbrs.service';
import { twinfieldTestComponent } from './twinfieldTest/twinfieldTest.component';
import { TwinfieldTestService } from '../../services/twinfieldTest.service';


const settingsAppModule: aboTheme.INgModule = {
  components: {
    settingsComponent,
    settingsCompanyComponent,
    employeeListComponent,
    employeeItemComponent,
    templatesEditorComponent,
    timezonesComponent,
    timezonesListComponent,
    timezonesItemComponent,
    timezonesItemBasicComponent,
    salaryScaleListComponent,
    salaryScalesDialogComponent,
    staffComponent,
    staffListComponent,
    staffItemComponent,
    masterdataComponent,
    masterdataListComponent,
    masterdataEditComponent,
    nmbrsTestComponent,
    twinfieldTestComponent,
    hourCodesComponent,
    hourCodesListComponent,
    hourCodesItemComponent,
    hourCodesItemBasicComponent
  },
  states: [
      settingsState,
      settingsCompanyState,
      settingsEmployeeState,
      settingsEmployeeListState,
      settingsEmployeeItemState,
      templatesState,
      timezonesState,
      timezonesListState,
      timezonesItemState,
      settingsSalaryScaleState,
      settingsSalaryScaleEditState,
      staffState,
      staffListState,
      staffItemState,
      masterdataListEditState,
      masterdataState,
      masterdataListState,
      nmbrsTestState,
      twinfieldTestState,
      hourCodesState,
      hourCodesListState,
      hourCodesItemState
  ],
  services: {
    PersonService, TemplatesService, TimezonesService, MasterdataAService, StaffService, SalaryScaleGroupService, SalaryScaleService, NmbrsService, TwinfieldTestService, HourCodeService
  }
};

loadNg1Module(ngmodule, settingsAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/settings/index.ts